import { ClientRender } from '@change-corgi/core/react/ssr/render';
import { Box, Flex } from '@change-corgi/design-system-legacy/layout';
import { useIsSunriseTheme } from '@change-corgi/design-system-legacy/theme';

import type { SupporterComment, SupporterCommentPetition } from '../../../../shared/types';
import { CommentLikes } from '../../../CommentLikes';
import { ReportComment } from '../../../ReportComment';

export function SupporterCommentCardFooter({
	supporterComment,
	petition,
}: {
	supporterComment: SupporterComment;
	petition: SupporterCommentPetition;
}): React.JSX.Element {
	const isSunriseThemeEnabled = useIsSunriseTheme();

	return (
		<ClientRender placeholder={<Box sx={{ height: 24 }} />}>
			<Flex sx={isSunriseThemeEnabled ? { gap: '16px' } : { gap: '10px' }}>
				<CommentLikes comment={supporterComment} />
				<ReportComment comment={supporterComment} petitionId={petition.id} petitionSlug={petition.slug} />
			</Flex>
		</ClientRender>
	);
}
